import WidgetMenu from './WidgetMenu';
export default WidgetMenu;



// WEBPACK FOOTER //
// ./src/components/WidgetMenu/index.js